﻿import {translation} from "@2d-front-monorepo/core";
import {
	AddressComponent,
	AttachmentsComponent,
	EntityHistoryStatusComponent, InstallationByHostData,
	PermitFullEntityResult, ResidencyPropertyFlags, ResidencyId,
	ResidencyResult,
	Zones
} from "@2d-front-monorepo/permits-business";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX} from "react";
import {API_ENDPOINT} from "../../../api-endpoint";

const filesPrefix = API_ENDPOINT.fileDownload;

export function ResidencyComponent({installation, residency, hiddenEntityProperties, showStatus}: {
	installation: InstallationByHostData,
	residency: PermitFullEntityResult<ResidencyId, ResidencyResult>,
	hiddenEntityProperties: ResidencyPropertyFlags,
	showStatus: boolean
}): JSX.Element {
	const zoneId = residency.entity.zoneId;
	const zone = Zones.get(installation, zoneId);

	return <div className="card card--residency">
		<header className="layout horizontal aligned middle">
			<h5 className="flex">{translation(PermitTranslations.residency)}</h5>
			{showStatus && <EntityHistoryStatusComponent status={residency}/>}
		</header>
		<hr className="no-margin"/>
		<div className="grid padded">
			{zoneId == null
				? undefined
				: <dl className="title-desc col-1of4">
					<dt>{translation(PermitTranslations.zone)}</dt>
					<dd>{zone!.name || zone!.id}</dd>
				</dl>
			}
			<dl className="title-desc col-1of2">
				<dt>{translation(PermitTranslations.address)}</dt>
				<dd><AddressComponent value={residency.entity} hiddenEntityProperties={hiddenEntityProperties}/></dd>
			</dl>
			<AttachmentsComponent entity={residency.entity} linkPrefix={filesPrefix} className="col-1of4"/>
		</div>
	</div>
}
